import * as React from 'react';
import {clsx} from 'clsx';
import IconFontAwesome from "../components/iconFontAwesome";

type Props = {
	className?: string,
}

function EmptyImage({ className, ...otherProps }: Props) {
	return (<>
		<div className={clsx("h-full flex flex-col justify-center items-center", className)} {...otherProps}>
			<IconFontAwesome className="icon-image text-8xl"/>
			<div className="text-xl">No image</div>
		</div>
	</>);
}

export default EmptyImage
